import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { TypeVoie } from '../models/TypeVoie';
@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
  	@Input() voie: TypeVoie;

    public step1 = new Step1();

  constructor() { }

  public ngOnInit() {
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
}

